<div class="box-table">

	<span class="title-accordion" [class.active]="!isCollapsed" (click)="isCollapsed = !isCollapsed"
		(keypress)="isCollapsed = !isCollapsed">
		{{ labels().MA_LT_RECAP_COMPONENT_TITLE }}
		<div class="fake-material-icon icon-expand expand"></div>
	</span>

	<table class="table" [ngbCollapse]="isCollapsed">
		<thead>
			<tr>
				<th></th>
				<th>{{ labels().MA_LT_RECAP_COMPONENT_VALUE_HEADER }} <br />
					({{ (isLeft ? sideEnum.Left : sideEnum.Right) | anatomicalSideLabel }})
				</th>
				<th>{{ labels().MA_LT_RECAP_COMPONENT_TARGET_HEADER }}</th>
			</tr>
		</thead>
		<tbody>
			@if (isPDFA) {
			<tr [class.row-selected]="!isValidPDFA">
				<td>{{ labels().MA_LT_RECAP_COMPONENT_PDFA }} <br /> {{ rangePDFA }}</td>
				<td>{{ rpmMeasures?.rpm_lt_PDFA }}</td>
				<td></td>
			</tr>
			}
			@if (isKneeTransl) {
			<tr [class.row-selected]="!isValidKneeTransl">
				<td>{{ labels().MA_LT_RECAP_COMPONENT_KNEE_TRANSL }} <br /> {{ rangeKneeTransl }}</td>
				<td>{{ rpmMeasures?.rpm_lt_kneeTranslation }}</td>
				<td></td>
			</tr>
			}
			@if (isPPTA) {
			<tr [class.row-selected]="!isValidPPTA">
				<td>{{ labels().MA_LT_RECAP_COMPONENT_PPTA }} <br /> {{ rangePPTA }}</td>
				<td>{{ rpmMeasures?.rpm_lt_PPTA }}</td>
				<td>{{ def_standardAngles_PPTA }}</td>
			</tr>
			}
			@if (isADTA) {
			<tr [class.row-selected]="!isValidADTA">
				<td>{{ labels().MA_LT_RECAP_COMPONENT_ADTA }} <br /> {{ rangeADTA }}</td>
				<td>{{ rpmMeasures?.rpm_lt_ADTA }}</td>
				<td>{{ def_standardAngles_ADTA }}</td>
			</tr>
			}
		</tbody>
	</table>

</div>